var MessageTheme = {
    Danger: 'danger',
    Warning: 'warning',
    Success: 'success',
    Info: 'info',
    InfoLayer1: 'info-layer-1',
    InfoLayer2: 'info-layer-2',
    AlertInfo: 'alert-info',
};
var MessageVariant = {
    Block: 'block',
    Inline: 'inline',
};
var MessageFontStyle = {
    Regular: 'regular',
    Italic: 'italic',
};

export { MessageFontStyle, MessageTheme, MessageVariant };
